export default __webpack_public_path__ + "static/media/arrow-long-left.b89097c0.svg";